import { GLOBAL_URL, fetchGet } from './global';

export const authenticateDbx = async () => {
	return await fetchGet(`${GLOBAL_URL}dbx/getUrl`);
};
export const getDropboxStatus = async () => {
	return await fetchGet(`${GLOBAL_URL}dbx/checkStatus`);
};
